import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const subjunctiveQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Espero que tú ___ a la fiesta.'",
        options: ["vienes", "vendrás", "vengas", "vieniste"],
        correctAnswerIndex: 2,
        explanation: "'Vengas' es la forma correcta porque se utiliza el subjuntivo en una oración que expresa un deseo o una esperanza, que es una situación no real o no confirmada."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma adecuada: 'Es importante que los niños ___ temprano.'",
        options: ["duermen", "duerman", "dormían", "durmieron"],
        correctAnswerIndex: 1,
        explanation: "'Duerman' es la forma correcta porque en una oración que expresa importancia o necesidad, se utiliza el subjuntivo en el presente para referirse a acciones que se consideran deseadas o necesarias."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la frase: 'Ojalá que ___ buen tiempo mañana.'",
        options: ["hace", "hará", "haga", "hacía"],
        correctAnswerIndex: 2,
        explanation: "'Haga' es la forma correcta, ya que se utiliza el subjuntivo en expresiones de deseo o esperanza, como en 'ojalá', para hablar de situaciones futuras inciertas."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Es posible que ellos ___ en casa esta tarde.'",
        options: ["están", "estén", "estaban", "estuvieron"],
        correctAnswerIndex: 1,
        explanation: "'Estén' es la forma correcta, ya que se usa el subjuntivo en frases que expresan duda, incertidumbre o posibilidad, en este caso sobre un evento futuro."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'No creo que ellos ___ la respuesta correcta.'",
        options: ["saben", "sabían", "sepan", "supieron"],
        correctAnswerIndex: 2,
        explanation: "'Sepan' es la forma correcta, ya que el subjuntivo se utiliza en oraciones negativas o que expresan duda, como en este caso."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma correcta: 'Si yo ___ rico, viajaría por todo el mundo.'",
        options: ["soy", "fuera", "era", "sería"],
        correctAnswerIndex: 1,
        explanation: "'Fuera' es la forma correcta, ya que en las oraciones condicionales, se utiliza el imperfecto de subjuntivo para expresar situaciones hipotéticas."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Quiero que tú ___ la tarea antes de irte.'",
        options: ["hagas", "hacías", "hizo", "haces"],
        correctAnswerIndex: 0,
        explanation: "'Hagas' es la forma correcta, porque el subjuntivo se utiliza en oraciones que expresan un deseo o una petición, como en este caso."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Es posible que ella ___ llegar tarde.'",
        options: ["puedo", "pudo", "podía", "pueda"],
        correctAnswerIndex: 3,
        explanation: "'Pueda' es la forma correcta porque en una oración que expresa posibilidad o incertidumbre se utiliza el subjuntivo."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma correcta: 'Si ellos ___ más, habrían aprobado el examen.'",
        options: ["estudiaron", "estudieran", "estudiaban", "estudiarán"],
        correctAnswerIndex: 1,
        explanation: "'Estudieran' es la forma correcta porque en las oraciones condicionales, se utiliza el imperfecto de subjuntivo para referirse a situaciones hipotéticas no ocurridas en el pasado."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Dudo que él ___ venir mañana.'",
        options: ["puede", "puede haber", "pueda", "podrá"],
        correctAnswerIndex: 2,
        explanation: "'Pueda' es la forma correcta, ya que se utiliza el subjuntivo después de verbos que expresan duda o incredulidad."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Es una pena que Juan no ___ aquí.'",
        options: ["está", "esté", "estaba", "estuvo"],
        correctAnswerIndex: 1,
        explanation: "'Esté' es la forma correcta, ya que se usa el subjuntivo después de expresiones de tristeza o pena sobre algo que no ha ocurrido."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma correcta: 'Es probable que ellos ___ estudiar toda la noche.'",
        options: ["tengan", "tienen", "tuvieron", "tendrán"],
        correctAnswerIndex: 0,
        explanation: "'Tengan' es la forma correcta, ya que el subjuntivo se usa para expresar duda o incertidumbre sobre una acción futura."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la frase: 'Ojalá que tú ___ bien en el examen.'",
        options: ["pasas", "pases", "pasaste", "pasarás"],
        correctAnswerIndex: 1,
        explanation: "'Pases' es la forma correcta, porque 'ojalá' requiere el uso del subjuntivo en situaciones de deseo o esperanza."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Es probable que ellos ___ la película mañana.'",
        options: ["ven", "vieron", "vean", "verán"],
        correctAnswerIndex: 2,
        explanation: "'Vean' es la forma correcta, porque 'es probable que' siempre se usa con el subjuntivo para expresar duda o posibilidad en el futuro."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma correcta: 'Me gustaría que tú ___ conmigo.'",
        options: ["viajas", "viajaras", "viajarás", "viajaste"],
        correctAnswerIndex: 1,
        explanation: "‘Viajaras’ es la forma correcta porque el verbo ‘gustaría’ expresa un deseo o una situación hipotética, lo que requiere el subjuntivo pasado (imperfecto de subjuntivo)."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la forma correcta: 'Es necesario que vosotros ___ el informe antes de la reunión.'",
        options: ["entendéis", "entendáis", "entendieron", "entendéis"],
        correctAnswerIndex: 1,
        explanation: "'Entendáis' es la forma correcta, porque se usa el subjuntivo después de verbos que indican necesidad o exigencia."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Espero que tú ___ el regalo que te compré.'",
        options: ["te gusta", "te gustó", "te gustes", "te guste"],
        correctAnswerIndex: 3,
        explanation: "'Te guste' es la forma correcta, ya que después de 'espero que' se debe usar el subjuntivo para expresar un deseo o esperanza."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Aunque él ___ bien, no podrá asistir.'",
        options: ["esté", "estaba", "estuvo", "estará"],
        correctAnswerIndex: 0,
        explanation: "'Esté' es la forma correcta, porque se utiliza el subjuntivo después de ‘aunque’ para expresar una situación que no es completamente real o que depende de otras circunstancias."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración: '___ (poner, ellos) el libro en la mesa.'",
        options: ["Pongan", "Pones", "Pusieron", "Pon"],
        correctAnswerIndex: 0,
        explanation: "'Pongan' es la forma correcta del verbo 'poner' en el imperativo afirmativo para la tercera persona plural (ellos/ellas)."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la opción correcta: 'Es posible que nosotros ___ tarde.'",
        options: ["llegamos", "lleguemos", "llegábamos", "llegaremos"],
        correctAnswerIndex: 1,
        explanation: "'Lleguemos' es la forma correcta, ya que se utiliza el subjuntivo en frases que expresan duda o posibilidad en el presente o futuro."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la forma correcta: 'Si tú ___ más tiempo, habrías terminado el trabajo.'",
        options: ["tienes", "tuviste", "tuvieras", "tenías"],
        correctAnswerIndex: 2,
        explanation: "'Tuvieras' es la forma correcta porque en las oraciones condicionales, se utiliza el imperfecto de subjuntivo para hablar de situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta imperativo: '___ (decir) la verdad.'",
        options: ["Di", "Dices", "Decirás", "Dijo"],
        correctAnswerIndex: 0,
        explanation: "'Di' es la forma correcta del verbo 'decir' en el imperativo afirmativo para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración: '___ (ser, nosotros) responsables de su trabajo.'",
        options: ["Seamos", "Somos", "Seremos", "Fuimos"],
        correctAnswerIndex: 0,
        explanation: "'Seamos' es la forma correcta del verbo 'ser' en el imperativo afirmativo para la primera persona plural (nosotros)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta: '___ (salir, vosotros) a la calle ahora mismo.'",
        options: ["Salid", "Sal", "Salieron", "Salgo"],
        correctAnswerIndex: 0,
        explanation: "'Salid' es la forma correcta del verbo 'salir' en el imperativo afirmativo para la segunda persona plural (vosotros)."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Selecciona la mejor opción: 'Es probable que ellos ___ tarde.'",
        options: ["traigan", "traen", "trajeron", "traerán"],
        correctAnswerIndex: 0,
        explanation: "'Traigan' es la forma correcta, ya que en frases que expresan probabilidad o duda sobre el futuro, se usa el subjuntivo."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta: '___ (venir, usted) aquí ahora.'",
        options: ["Ven", "Vas", "Vino", "Venga"],
        correctAnswerIndex: 0,
        explanation: "'Ven' es la forma correcta del verbo 'venir' en el imperativo afirmativo para la segunda persona singular (tú)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Elige la forma correcta: '___ (tener) cuidado con lo que decís.'",
        options: ["Tenéis", "Tengan", "Tened", "Ten"],
        correctAnswerIndex: 2,
        explanation: "'Tened' es la forma correcta del verbo 'tener' en el imperativo afirmativo para la segunda persona plural (vosotros)."
    },
    {
        category: QuizCategory.IMPERATIVE,
        questionText: "Completa la oración: '___ (decir, nosotros) lo que piensan.'",
        options: ["Digamos", "Decimos", "Dirán", "Dijeron"],
        correctAnswerIndex: 0,
        explanation: "'Digamos' es la forma correcta del verbo 'decir' en el imperativo afirmativo para la primera persona plural (nosotros)."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la forma correcta: 'Si usted ___ (venir) más temprano, habría evitado el problema.'",
        options: ["viniera", "viene", "vino", "vendría"],
        correctAnswerIndex: 0,
        explanation: "'Viniera' es la forma correcta del verbo 'venir' en el pretérito imperfecto del subjuntivo, usado en situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Es posible que vosotros ___ a la fiesta mañana.'",
        options: ["vais", "vayáis", "iréis", "fuisteis"],
        correctAnswerIndex: 1,
        explanation: "'Vayáis' es la forma correcta, ya que se usa el subjuntivo en oraciones que expresan duda, deseo o incertidumbre sobre el futuro."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la forma correcta: 'Si tú ___ (saber) la respuesta, habrías pasado el examen.'",
        options: ["sabías", "supiste", "supieras", "sabrías"],
        correctAnswerIndex: 2,
        explanation: "'Supieras' es la forma correcta del verbo 'saber' en el pretérito imperfecto del subjuntivo, usado en oraciones hipotéticas o condicionales."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Si nosotros ___ (haber) estudiado más, habríamos aprobado el examen.'",
        options: ["hubiéramos", "habíamos", "hubieron", "habría"],
        correctAnswerIndex: 0,
        explanation: "'Hubiéramos' es la forma correcta del verbo 'haber' en el pretérito pluscuamperfecto del subjuntivo, que se usa para situaciones hipotéticas pasadas."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'No me parece que vosotros ___ en casa.'",
        options: ["estáis", "estéis", "estabais", "estuvieron"],
        correctAnswerIndex: 1,
        explanation: "'Estéis' es la forma correcta, porque en oraciones negativas que expresan duda o desconfianza se usa el subjuntivo."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Ojalá que tú ___ a la boda.'",
        options: ["vas", "fuiste", "irás", "vayas"],
        correctAnswerIndex: 3,
        explanation: "'Vayas' es la forma correcta, ya que se utiliza el subjuntivo después de expresiones como 'ojalá' para desear algo."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Completa la oración: 'Si vosotros ___ (decir) la verdad, habríais evitado problemas.'",
        options: ["dijerais", "decíais", "dijeron", "deciréis"],
        correctAnswerIndex: 0,
        explanation: "'Dijerais' es la forma correcta del verbo 'decir' en el pretérito imperfecto del subjuntivo, usado para situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Si él ___ (ir) al evento, habría sido un éxito.'",
        options: ["iba", "fue", "iría", "fuera"],
        correctAnswerIndex: 3,
        explanation: "'Fuera' es la forma correcta del verbo 'ir' en el pretérito imperfecto del subjuntivo, usado para expresar una condición no cumplida en el pasado."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la forma correcta: 'Si nosotros ___ (hacer) más ejercicio, estaríamos más saludables.'",
        options: ["hiciéramos", "hacíamos", "hicieron", "haríamos"],
        correctAnswerIndex: 0,
        explanation: "'Hiciéramos' es la forma correcta del verbo 'hacer' en el pretérito imperfecto del subjuntivo, usada para situaciones hipotéticas."
    },
    {
        category: QuizCategory.SUBJUNCTIVE,
        questionText: "Elige la opción correcta: 'Me alegra que tú ___ aprobado el examen.'",
        options: ["has", "haber", "haya", "haberá"],
        correctAnswerIndex: 2,
        explanation: "'Haya' es la forma correcta, ya que el subjuntivo se usa en oraciones que expresan alegría o satisfacción sobre algo que ha sucedido."
    }
];

export default subjunctiveQuestions;